"use strict";

exports.__esModule = true;
exports.default = void 0;

var _TrackVisibility = _interopRequireDefault(require("./TrackVisibility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* This file seems a bit useless anyway
* */
var _default = _TrackVisibility.default;
exports.default = _default;